import { render, staticRenderFns } from "./benefits-tabs.vue?vue&type=template&id=e0babe34&scoped=true"
import script from "./benefits-tabs.vue?vue&type=script&lang=js"
export * from "./benefits-tabs.vue?vue&type=script&lang=js"
import style0 from "./benefits-tabs.vue?vue&type=style&index=0&id=e0babe34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0babe34",
  null
  
)

export default component.exports